import { render, staticRenderFns } from "./LibraryDependency.vue?vue&type=template&id=088dee8e&"
import script from "./LibraryDependency.vue?vue&type=script&lang=js&"
export * from "./LibraryDependency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports